export function modifyDate(date: Date): Date {
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - userTimezoneOffset);
}

export function modifyDates(data: Record<string, unknown>): void {
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const value = data[key];
      if (value instanceof Date) {
        data[key] = modifyDate(value);
      }
    }
  }
}
